module.exports = __webpack_public_path__ + "img/thumbnail_SandCat_j_normal.6d07701f.png";